module.exports = __webpack_public_path__ + "img/dcrlj.e628a4ea.jpg";